import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Le Levain",
    testid: "manifesto-chapter-1",
    text: "Notre pâte fermente 72 heures à froid. Une maturation lente qui développe des arômes profonds et une alvéolation légère, digeste, irrégulière — la signature d'une vraie pizza napolitaine.",
    quote: "Le temps est notre premier ingrédient.",
    img: "https://images.unsplash.com/photo-1537734796389-e1fc293cf856?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxnb3VybWV0JTIwbmVhcG9saXRhbiUyMHBpenphJTIwaW5ncmVkaWVudHxlbnwwfHx8fDE3ODgzMzU4NTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "02",
    title: "Le Sourcing",
    testid: "manifesto-chapter-2",
    text: "Chez PALMI Pizza Club, nous privilégions des produits de qualité, choisis avec soin pour respecter l'esprit de la tradition italienne. Tomates italiennes, mozzarella Fior di Latte, farine italienne et ingrédients frais composent nos pizzas au quotidien. Nous travaillons également en direct avec des producteurs et commerçants locaux, afin de valoriser les savoir-faire de notre région et de créer des liens avec les acteurs qui nous entourent.",
    quote: "Des produits italiens, des produits locaux, et surtout beaucoup de passion.",
    img: "https://images.unsplash.com/photo-1579751626657-72bc17010498?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxhcnRpc2FuJTIwcGl6emElMjB3b29kJTIwZmlyZWQlMjBvdmVufGVufDB8fHx8MTc4ODMzNTg1OHww&ixlib=rb-4.1.0&q=85",
  },
  {
    num: "03",
    title: "Le Feu",
    testid: "manifesto-chapter-3",
    text: "90 secondes à 450°C dans notre four à bois. La mozzarella fond sans graisser. Un extérieur croustillant avec des bords aérés et moelleux, sans dessécher la pâte.",
    quote: "Le feu ne pardonne pas l'approximation.",
    img: "https://images.unsplash.com/photo-1606152196365-d1ce5ea838b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHszfHxhcnRpc2FuJTIwcGl6emElMjB3b29kJTIwZmlyZWQlMjBvdmVufGVufDB8fHx8MTc4ODMzNTg1OHww&ixlib=rb-4.1.0&q=85",
  },
];

const fadeUp = {
  initial: { opacity: 0, y: 32 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-36">
      <motion.p {...fadeUp} className="overline-label">Le manifesto</motion.p>
      <motion.h2 {...fadeUp} className="font-display mt-4 max-w-3xl text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
        Trois étapes, <span className="font-editorial italic text-terra">une obsession.</span>
      </motion.h2>

      <div className="mt-20 space-y-24 lg:space-y-32">
        {CHAPTERS.map((c, i) => (
          <motion.article
            key={c.num}
            data-testid={c.testid}
            {...fadeUp}
            className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""}`}
          >
            <div className="group relative overflow-hidden rounded-2xl border border-border/60">
              <img
                src={c.img}
                alt={c.title}
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
              />
              <span className="font-display absolute left-5 top-5 rounded-full bg-background/70 px-4 py-1.5 text-sm font-bold text-ochre backdrop-blur-md">
                {c.num}
              </span>
            </div>
            <div>
              <p className="font-code text-xs uppercase tracking-[0.3em] text-terra">Chapitre {c.num}</p>
              <h3 className="font-display mt-3 text-2xl font-bold sm:text-3xl">{c.title}</h3>
              <p className="mt-4 text-base leading-relaxed text-dim">{c.text}</p>
              <p className="font-editorial mt-6 border-l-2 border-terra pl-4 text-xl italic text-ochre sm:text-2xl">
                « {c.quote} »
              </p>
            </div>
          </motion.article>
        ))}
      </div>
    </section>
  );
}
